import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = () => {
  const { t } = useLanguage();
  const faqItems = t('faq.items') || [];

  return (
    <section id="faq" className="py-24 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <p
            className="inline-block rounded-full border border-black/15 bg-black/5 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-black/60 mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {t('faq.badge')}
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold mb-4">{t('faq.title')}</h2>
          <p className="text-xl text-gray-600">
            {t('faq.description')}
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqItems.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-gradient-to-br from-gray-50 to-white border-2 border-gray-200 rounded-2xl px-6 hover:border-black transition-all duration-300 hover:shadow-lg"
            >
              <AccordionTrigger className="text-left font-semibold text-lg py-6 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;